import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive } from "vue";
import { GetKeyMaterialPage, GetKeyMaterialDetail } from "@/api/keyMaterial";
import { postDownload } from "@/utils";

export default function useStashTable() {
  const searchRef = ref(null); // 搜索ref
  // 搜索条件
  const searchData = reactive({
    number: null,
    materialName: null,
    materialCategoryName: null,
  });
  const lifecycleRef = ref(null); // 新增弹窗ref

  const tableLoading = ref(false); // 表格loading

  // 表格列配置
  const columns = ref([
    {
      label: "表具编号",
      prop: "number",
      width: 160,
    },
    {
      label: "物料名称",
      prop: "materialName",
      width: 160,
    },
    {
      label: "物料编号",
      prop: "materialNumber",
      width: 120,
    },
    {
      label: "物料类别",
      prop: "materialCategoryName",
      width: 120,
    },
    {
      label: "规格型号",
      prop: "materialModel",
      width: 120,
    },
    {
      label: "单位",
      prop: "materialUnit",
      width: 120,
    },
    {
      label: "入库时间",
      prop: "inTime",
      width: 160,
    },
    {
      label: "出库时间",
      prop: "outTime",
      width: 160,
    },
    {
      label: "安装时间",
      prop: "installTime",
      width: 160,
    },
    {
      label: "更换时间",
      prop: "changeTime",
      width: 160,
    },
    {
      label: "报废时间",
      prop: "scrapTime",
      width: 160,
    },
    {
      label: "报废入库时间",
      prop: "scrapInTime",
      width: 160,
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 分页参数
  const pages = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pages.size = val;
    pages.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pages.page = val;
    getList();
  };
  const indexMethod = (index) => {
    // 计算连续序号
    return (pages.page - 1) * pages.size + index + 1;
  };
  // 获取列表数据
  const getList = () => {
    tableLoading.value = true;
    GetKeyMaterialPage({
      ...searchData,
      page: pages.page,
      limit: pages.size,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 搜索条件重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    searchData.number = null;
    searchData.materialName = null;
    searchData.materialCategoryName = null;

    pages.page = 1;
    getList();
  };

  // 查看
  const handleLifecycle = (row) => {
    GetKeyMaterialDetail(row.id).then((res) => {
      lifecycleRef.value?.handleDialogOpen(row, res.data);
    });
  };

  return {
    searchRef,
    searchData,
    tableLoading,
    columns,
    tableData,
    pages,
    lifecycleRef,
    indexMethod,
    getList,
    handleSizeChange,
    handleCurrentChange,
    handleReset,
    handleLifecycle,
  };
}
